import { render, staticRenderFns } from "./ximeiChangeEdit.vue?vue&type=template&id=09ba8abb&scoped=true&"
import script from "./ximeiChangeEdit.vue?vue&type=script&lang=js&"
export * from "./ximeiChangeEdit.vue?vue&type=script&lang=js&"
import style0 from "./ximeiChangeEdit.vue?vue&type=style&index=0&id=09ba8abb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ba8abb",
  null
  
)

export default component.exports